// Stock photo crowd component using copyright-free Unsplash photographs.
// Replaces the previous Medicys cartoon people illustrations.

const PEOPLE = [
  { src: "/images/photos/woman-1.jpg", alt: "" },
  { src: "/images/photos/man-1.jpg", alt: "" },
  { src: "/images/photos/woman-2.jpg", alt: "" },
  { src: "/images/photos/man-2.jpg", alt: "" },
  { src: "/images/photos/woman-3.jpg", alt: "" },
  { src: "/images/photos/man-3.jpg", alt: "" },
  { src: "/images/photos/woman-4.jpg", alt: "" },
  { src: "/images/photos/man-4.jpg", alt: "" },
];

// Crowd of overlapping circular avatars, used on About + FAQ pages.
export const PeopleCrowd = () => (
  <div className="flex items-center justify-center -space-x-4 md:-space-x-5 px-4">
    {PEOPLE.map((p, i) => (
      <div
        key={i}
        className="relative w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden ring-4 ring-[var(--charcoal)] shadow-lg"
        style={{ zIndex: PEOPLE.length - i }}
      >
        <img
          src={p.src}
          alt={p.alt}
          loading="lazy"
          className="w-full h-full object-cover"
        />
      </div>
    ))}
  </div>
);

// Single avatar , used in sign-up page heroes (small accent on the side).
export const PersonAvatar = ({
  src = "/images/photos/woman-2.jpg",
  className = "w-24 h-24 md:w-32 md:h-32",
  alt = "",
}) => (
  <div
    className={`rounded-full overflow-hidden ring-4 ring-[var(--lime)] shadow-xl flex-shrink-0 ${className}`}
  >
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="w-full h-full object-cover"
    />
  </div>
);

// Larger lifestyle hero photo for top-level patient/caregiver pages.
export const HeroLifestyle = ({
  src = "/images/photos/hero-patient.jpg",
  alt = "",
  className = "",
}) => (
  <div
    className={`relative rounded-3xl overflow-hidden shadow-2xl ring-1 ring-white/10 ${className}`}
  >
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="w-full h-full object-cover"
    />
    {/* Subtle warm gradient overlay so the dark hero text stays readable */}
    <div className="absolute inset-0 bg-gradient-to-tr from-[var(--charcoal)]/30 via-transparent to-transparent pointer-events-none" />
  </div>
);
